<template>

    <div>

        <div class="user-lists-hero">

            <svg class="save"><use xlink:href="#save"></use></svg>

            <h2>My Lists</h2>

            <p>
                Planning for a weekend in Austin? Dreaming of a trip to Costa Rica? Have great recs for can’t-miss wineries in Napa? Create personalized lists to easily save and share all your favorite spots.
            </p>

            <div class="lists-action-buttons">

                <Filters :options="filters"></Filters>

                <button class="create-list-trigger" @click="createList()">
                    Create List
                    <span><svg class="pen"><use xlink:href="#pen"></use></svg></span>
                </button>
            </div>
        </div>

        <div class="user-lists-grid">

            <template v-for="(list, index) in lists">
                <ListBloq v-model="lists[index]" :index="index" :current-user="currentUser"></ListBloq>
            </template>

            <div class="user-lists-item create-list-trigger" @click="createList()">
                <div class="content">
                    <span><svg class="pen"><use xlink:href="#pen"></use></svg></span>
                    <h3>Create List</h3>
                </div>
            </div>

        </div>

    </div>

</template>

<script>

import ListBloq from './ListBloq'
import Filters from './Filters'
import Helpers from '@/mixins/Helpers'

export default {

    mixins:[Helpers],

    components:{
        Filters,
        ListBloq
    },

    props: ['data', 'filters'],

    data() {
        return {
            currentUser: config.user,
            lists: [],
            selectedIndex: 0,
            selectedList: {}
        }
    },

    mounted() {
        this.lists = this.data
    },

    created() {
        eventBus.$on('set-list-active', event => {
            this.selectedIndex = event.listIndex
        });
        eventBus.$on('list-created', data => {
            this.lists.unshift(data.list);
        });
        eventBus.$on('list-updated', data => {
            this.lists.splice(this.selectedIndex, 1, data.list);
        });
        eventBus.$on('list-deleted', data => {
            this.lists.splice(this.selectedIndex, 1);
        });
    },

    methods: {

        setActive(setList) {
            this.lists.forEach((list, index) => {
                list.active = false;
            });
            setList.active = true;
        },

        setInactive(setList) {
            setList.active = false;
        },

        createList() {
            eventBus.$emit('open-create-list-modal');
        },
    }
}
</script>
